import React from 'react';
import propTypes from 'prop-types';
import { ErrorMessages } from '@bingads-webui-react/validation';

export const SystemErrors = ({ errors }) => (
  <div className="system-errors">
    <ErrorMessages messages={errors} />
  </div>
);

SystemErrors.propTypes = {
  errors: propTypes.arrayOf(propTypes.string),
};

SystemErrors.defaultProps = {
  errors: [],
};
